export const PAGE_SIZE = 9;

export const slugify = (s: string) => s.toLowerCase().trim().replace(/\s+/g, '-');

export const dedupeById = <T extends { id: string }>(arr: T[]) => {
  const map = new Map<string, T>();
  for (const it of arr) map.set(String(it.id), it);
  return Array.from(map.values());
};
